import { AddressFormats } from '../Enums/AddressFormats';
import { formatMessage } from '../Localization/formatMessage';
import Messages from '../Localization/Messages';
import { hasFieldChangedValue } from './FormInputHelper';

export const COUNTRY_CODE_DENMARK = 'DK';
export const COUNTRY_CODE_FINLAND = 'FI';
export const COUNTRY_CODE_NORWAY = 'NO';
export const COUNTRY_CODE_SWEDEN = 'SE';
export const COUNTRY_CODE_GREENLAND = 'GL';

// not in use currently
export const addressTypes = {
  Primary: 'Primary',
  Visiting: 'Visiting',
  Invoice: 'Invoice',
  Other: 'Other',
};

export const careOfFields = [
  {
    id: 1,
    value: 'None',
  },
  {
    id: 2,
    value: 'Co',
  },
  {
    id: 3,
    value: 'V',
  },
  {
    id: 4,
    value: 'Attn',
  },
];

export const getFormattedAddress = address => {
  if (address === undefined || address === null) return null;
  if (address.format === AddressFormats.Street)
    return `${address.streetName} ${address.houseNumber || ''}${address.houseLetter || ''} ${address.city || ''}`;
  if (address.format === AddressFormats.Foreign)
    return `${address.addressLine1} ${address.addressLine2 || ''} ${address.city || ''} ${address.country?.name || ''}`;
  if (address.format === AddressFormats.POBox)
    return `${address.format} ${address.number || ''} ${address.facilityName || ''} ${address.postalCode ||
      ''} ${address.city || ''}`;
  if (address.format === AddressFormats.FreeText)
    return `${address.format} ${address.country?.name} ${address.additionalAddress || ''}`;
  if (address.format === AddressFormats.Unstructured)
    return `${address.addressLine1} ${address.addressLine2 || ''} ${address.postalCode || ''} ${address.city || ''}`;
};

export const hasAnyFieldChanged = (address, initialAddress) => {
  if (hasFieldChangedValue(address.format, initialAddress.format)) {
    return true;
  }

  switch (address.format) {
    case AddressFormats.Street: {
      return (
        haveCommonFieldsChanged(address, initialAddress) ||
        hasFieldChangedValue(address.streetName, initialAddress.streetName) ||
        hasFieldChangedValue(address.houseNumber, initialAddress.houseNumber) ||
        hasFieldChangedValue(address.houseLetter, initialAddress.houseLetter) ||
        hasFieldChangedValue(address.apartmentNumber, initialAddress.apartmentNumber) ||
        hasFieldChangedValue(address.additionalAddress, initialAddress.additionalAddress)
      );
    }
    case AddressFormats.Foreign: {
      return (
        hasFieldChangedValue(address.city, initialAddress.city) ||
        hasFieldChangedValue(address.country?.name, initialAddress.country?.name) ||
        hasFieldChangedValue(address.addressLine1, initialAddress.addressLine1) ||
        hasFieldChangedValue(address.addressLine2, initialAddress.addressLine2) ||
        hasFieldChangedValue(address.addressLine3, initialAddress.addressLine3)
      );
    }
    case AddressFormats.POBox: {
      return (
        haveCommonFieldsChanged(address, initialAddress) ||
        hasFieldChangedValue(address.number, initialAddress.number) ||
        hasFieldChangedValue(address.facilityName, initialAddress.facilityName)
      );
    }
    case AddressFormats.Unstructured: {
      return (
        haveCommonFieldsChanged(address, initialAddress) ||
        hasFieldChangedValue(address.addressLine1, initialAddress.addressLine1) ||
        hasFieldChangedValue(address.addressLine2, initialAddress.addressLine2) ||
        hasFieldChangedValue(address.addressLine3, initialAddress.addressLine3)
      );
    }
    default: {
      throw Error('Unknown format.', address.format);
    }
  }
};

const haveCommonFieldsChanged = (address, initialAddress) => {
  return (
    haveCareOfFieldsChanged(address, initialAddress) ||
    hasFieldChangedValue(address.city, initialAddress.city) ||
    hasFieldChangedValue(address.postalCode, initialAddress.postalCode) ||
    hasFieldChangedValue(address.country?.name, initialAddress.country?.name)
  );
};
const haveCareOfFieldsChanged = (address, initialAddress) => {
  return (
    hasFieldChangedValue(address.careOf?.name, initialAddress.careOf?.name) ||
    hasFieldChangedValue(address.careOf?.prefix, initialAddress.careOf?.prefix)
  );
};

export const areFieldsValid = address => {
  if (!address) return true;

  if (address.format !== AddressFormats.Foreign && !areCommonFieldsValid(address)) {
    return false;
  }

  switch (address.format) {
    case AddressFormats.Street: {
      if (!address.streetName?.trim() || !address.houseNumber?.trim()) {
        return false;
      }
      return true;
    }
    case AddressFormats.Foreign: {
      if (!address.addressLine1?.trim() || !address.country?.name?.trim()) {
        return false;
      }
      return true;
    }
    case AddressFormats.FreeText: {
      return false;
    }
    case AddressFormats.POBox: {
      if (!address.number?.trim()) {
        return false;
      }
      return true;
    }
    case AddressFormats.Unstructured: {
      if (!address.addressLine1?.trim()) {
        return false;
      }
      return true;
    }
    default: {
      console.log('Unknown format.', address.format);
    }
  }
};

const areCommonFieldsValid = address => {
  if (!address.city?.trim() || !address.postalCode?.trim() || !address.country) {
    return false;
  }
  return true;
};

export const mapAddressFormatsToSelect = () => {
  return [
    { key: 1, value: AddressFormats.Street, displayName: formatMessage(Messages.addressInfo_StreetAddress) },
    { key: 2, value: AddressFormats.Foreign, displayName: formatMessage(Messages.addressInfo_ForeignAddress) },
    { key: 3, value: AddressFormats.POBox, displayName: formatMessage(Messages.addressInfo_POBoxAddress) },
    {
      key: 4,
      value: AddressFormats.Unstructured,
      displayName: formatMessage(Messages.addressInfo_UnstructuredAddress),
    },
  ];
};

/**
For creating a new address API expects different fields, than GET response provides.
 */
export const mapAddressFieldsToApiFormat = address => {
  return {
    ...address,
    countryCode: address.country?.code,
    pOBoxFacilityName: address.facilityName,
    pOBoxNumber: address.number,
  };
};
